import { Box, FlexLayout } from '@deity/falcon-ui';
import type { FC } from 'react';
import type React from 'react';
import { useState } from 'react';

interface ITooltipProps {
  isActive?: boolean;
  delay?: number;
  content?: React.ReactNode;
  bgColor?: string;
  color?: string;
  arrowSize?: string;
  minWidth?: string;
  margin?: string;
  direction?: 'top' | 'bottom' | 'left' | 'right';
}
export const Tooltip: FC<ITooltipProps> = ({
  delay = 400,
  isActive = false,
  content,
  bgColor = 'black',
  color = 'white',
  minWidth = '200px',
  margin = '10px',
  arrowSize = '6px',
  direction = 'top',
  children
}) => {
  let timeout;
  const [active, setActive] = useState(isActive);
  const showTip = () => {
    timeout = setTimeout(() => {
      setActive(true);
    }, delay);
  };

  const hideTip = () => {
    clearInterval(timeout);
    setActive(false);
  };

  const directionStyle = (direc: 'top' | 'bottom' | 'left' | 'right') => {
    const styles = {
      top: {
        style: { top: `calc(${margin} * -1)` },
        pseudo: {
          top: '100%',
          borderTopColor: bgColor
        }
      },
      right: {
        style: {
          left: `calc(100% + ${margin})`,
          top: '50%',
          transform: 'translateX(0) translateY(-50%)'
        },
        pseudo: {
          left: `calc(${arrowSize} * -1)`,
          top: '50%',
          transform: 'translateX(0) translateY(-50%)',
          borderRightColor: bgColor
        }
      },
      bottom: {
        style: {
          bottom: `calc(${margin} * -1)`
        },
        pseudo: {
          bottom: '100%',
          borderBottomColor: bgColor
        }
      },
      left: {
        style: {
          left: 'auto',
          right: `calc(100% + ${margin})`,
          top: '50%',
          transform: 'translate(0,-50%)'
        },
        pseudo: {
          left: 'auto',
          right: `calc(${arrowSize} * -2)`,
          top: '50%',
          transform: 'translate(0,-50%)',
          borderLeftColor: bgColor
        }
      }
    };

    return styles[direc];
  };

  return (
    <FlexLayout onMouseEnter={showTip} onMouseLeave={hideTip} position="relative">
      {children}
      {active && (
        <Box
          position="absolute"
          css={{
            borderRadius: '4px',
            left: '50%',
            transform: 'translateX(-50%)',
            padding: '6px',
            color,
            background: bgColor,
            fontSize: '14px',
            lineHeight: 1,
            zIndex: 100,
            minWidth,
            whiteSpace: 'break-spaces',
            ...directionStyle(direction).style,
            '&:before': {
              content: '""',
              left: '50%',
              border: 'solid transparent',
              height: 0,
              width: 0,
              position: 'absolute',
              pointerEvents: 'none',
              borderWidth: arrowSize,
              marginLeft: `calc(${arrowSize} * -1)`,
              ...directionStyle(direction).pseudo
            }
          }}
        >
          {content}
        </Box>
      )}
    </FlexLayout>
  );
};
